// extracted by mini-css-extract-plugin
module.exports = {"currency":"Amount_currency__1vU60","value":"Amount_value__1wwR4","container":"Amount_container__32VIv"};